import React from "react";
import { Button, IconButton } from "@virkesborsen/ui-component-library";
import styled from "styled-components";

export const BackButton = ({ handleBack, hide }) => {
  const isMobile = window.innerWidth < 768;

  return (
    <BackContainer>
      {!hide &&
        (isMobile ? (
          <IconButton
            label="Close"
            icon="ChevronDownSimple"
            onClick={handleBack}
            rotation={90}
          />
        ) : (
          <Button
            label="Tillbaka"
            onClick={handleBack}
            prefixIcon="ChevronDownSimple"
            variant="tertiary"
            rotation={90}
          />
        ))}
    </BackContainer>
  );
};

export const CloseButton = ({ handleClose }) => {
  const isMobile = window.innerWidth < 768;

  return (
    <CloseContainer>
      {isMobile ? (
        <IconButton label="Stäng" icon="CrossSimple" onClick={handleClose} />
      ) : (
        <Button
          label="Stäng"
          suffixIcon="CrossSimple"
          onClick={handleClose}
          variant="tertiary"
        />
      )}
    </CloseContainer>
  );
};

const BackContainer = styled.div`
  min-width: 107px;
  display: flex;
  justify-content: start;
  min-width: 107px;

  @media (max-width: 767px) {
    min-width: 44px;
  }
`;

const CloseContainer = styled.div`
  min-width: 107px;
  display: flex;
  justify-content: end;
  min-width: 107px;

  @media (max-width: 767px) {
    min-width: 44px;
  }
`;
